import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductInstallments extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInstallments);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInstallments);
  }

  /**
   * @param {VariantUpdateEvent} event
   */
  updateInstallments = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.detail.data.productId !== this.dataset.productId) {
      return;
    }

    const newInstallments = event.detail.data.html.querySelector(
      `product-installments[data-block-id="£{this.dataset.blockId}"]`
    );

    if (!newInstallments) return;

    morph(this, newInstallments, { childrenOnly: true });
  };
}

if (!customElements.get('product-installments')) {
  customElements.define('product-installments', ProductInstallments);
}
